import { render, staticRenderFns } from "./LsDepart.vue?vue&type=template&id=6aa4abec&"
import script from "./LsDepart.vue?vue&type=script&lang=js&"
export * from "./LsDepart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports